import { CriteriaType, FILTERS_SA_TYPE } from '@constants'
import { GETCriteriaType } from '@types'

class SearchAssistantCriteriasMapper {
  static toModel(dto: GETCriteriaType): CriteriaType {
    return {
      id: dto.id,
      title: dto.title,
      codeCriteria: dto.code,
      objectCode: dto.objectCode,
      order: dto.order,
      storedValues: dto.values
        ? dto.values.map(criteria => ({
            ...criteria,
            searchRule: criteria?.searchRule || FILTERS_SA_TYPE.EQUAL,
            value: '',
          }))
        : [],
      isPinning: dto.isPinning,
      visibility: dto.visibility,
    }
  }
}

export { SearchAssistantCriteriasMapper }
